import { functions } from "../data/data";

export default function FunctionAnalysis( { sourcecode } ){
    
    let lines = sourcecode.split("\n").map(line => line.trim());

    let data = functions.map( func => ({
        name: func.name,
        level : func.level,
        cnt: 0
    }));

    function checkForFunction(line, functionName) {
        let codeLine = line.replace(/".*?"/g, '').replace(/'.*?'/g, '');
        
        codeLine = codeLine.replace(/\/\/.*$/g, '').replace(/\/\*.*?\*\//g, '');
        
        if (functionName.includes('.')) {
            let [obj, method] = functionName.split('.');
            let pattern = new RegExp(`\\b${obj}\\s*\\.\\s*${method}\\b`, 'g');
            return codeLine.match(pattern) !== null;
        }
        
        let pattern = new RegExp(`\\b${functionName.replace('(', '')}\\s*\\(`, 'g');
        return codeLine.match(pattern) !== null;
    }

    for (let line of lines) {
        for (let i = 0; i < functions.length; i++) {
            let functionName = functions[i].name.replace('(', '');
            if (checkForFunction(line, functionName)) {
                data[i].cnt += 1;
            }
        }
    }

    data = data.filter(item => {
        if (item.cnt === 0) {
            return false;
        }
        return true;
    });

    data.sort(function (a, b) {
        return b.cnt - a.cnt;
    });

    return(
        <div key = { sourcecode.id }>
            <h3>Function Analysis ({ data.length }) :</h3>
            <p className = "meta3" style = { { padding : "8px 0px"} }>frequency · function name · difficulty</p>

            { data.map( ( item, index ) => {
                return(
                    <div key = { index } className = "td" style = { { display : "flex", alignItems : "center", gap : "8px" } }>
                        <p className = "meta3">{ item.cnt } ·</p>
                        <p className = "meta2">{ item.name  + ")" }</p>

                        <div style = {{ display: "flex", alignItems: "center", gap: "2px" }}>
                            { Array.from( { length: 3 } ).map((_, i) => (
                                <span key = {i} style={{
                                    width: "4px",
                                    height: "4px",
                                    backgroundColor: "var(--ptR)",
                                    opacity: i < item.level ? 1.0 : 0.1, // Color as much as the level
                                    display: "inline-block",
                                }}
                                />
                            ))}
                        </div>

                    </div>
            )})}
        </div>
    )
}